import { createContext } from 'react';
import CmsPackageService from '../Services/CmsPackageService';

const CmsPackageContext = createContext<CmsPackageService>(new CmsPackageService());

export default CmsPackageContext;
